import { Environment } from "./types/environment.type";

export const environment: Environment = {
    apiUrl: "https://api.jobimag.recursyve.dev",
    sentry: {
        dsn: "https://79f87faef79e20cca8da491541f75c15@o341312.ingest.us.sentry.io/4509039083192321",
        enabled: true,
        environment: "staging",
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["https://api.jobimag.recursyve.dev"],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    },
    firebase: {
        projectId: "jobimag-dev",
        appId: "1:428581211479:web:ef46bc4680e44ea4fd4212",
        storageBucket: "jobimag-dev.firebasestorage.app",
        apiKey: "AIzaSyBvxQHaq0jP7ZBfxYRVIOrPWG_lLcROJSw",
        authDomain: "jobimag-dev.firebaseapp.com",
        messagingSenderId: "428581211479"
    },
    language: {
        defaultLang: "fr",
        availableLangs: ["en", "fr"]
    }
};
